export default "__VITE_ASSET__Blh7bMkO__";